import { type FC } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";
import { formatNumberByThousands } from "widgets/utils";

import { type NuFeature } from "../../../graphql.js";
import { ContigTile, GenomeViewTile } from "../../core/tiles/index.js";

export interface INuFeatureCardProps extends GridCard {
  nuFeature: NuFeature;
}

const NuFeatureCard: FC<INuFeatureCardProps> = ({ nuFeature }) => {
  if (!nuFeature) {
    return null;
  }

  return (
    <Card key="marker-info-card" title={"Nucleotide Feature Info"}>
      <CardRowSimple label={"Type"}>{nuFeature.nuFeatureType.name}</CardRowSimple>
      <CardRowSimple label={"Name"}>{nuFeature.name}</CardRowSimple>
      <CardRowSimple label={"Description"}>{nuFeature.description}</CardRowSimple>
      <CardRowSimple label={"p-value"}>{nuFeature.pValue}</CardRowSimple>
      <CardRowSimple label={"Score"}>{nuFeature.score}</CardRowSimple>
      <CardRowSimple label={"Contig"}>
        <ContigTile contig={nuFeature.region?.contig} />
      </CardRowSimple>
      <CardRowSimple label={"Range"}>
        <GenomeViewTile
          title={`${formatNumberByThousands(nuFeature.region?.range.start)} – ${formatNumberByThousands(
            nuFeature.region?.range.stop,
          )} (${nuFeature.region?.strand})`}
          to={nuFeature.genome.id !== 0 ? `/nuFeature/${nuFeature.id}/genome` : undefined} // Range is not mandatory and the GenomeView of an entity is automatically set./>
          tooltip={
            nuFeature.genome.id === 0
              ? "Genome view is not available because this feature does not belong to a specific genome."
              : undefined
          }
        >
          {formatNumberByThousands(nuFeature.region?.range.stop - nuFeature.region?.range.start + 1)} bp
        </GenomeViewTile>
      </CardRowSimple>
    </Card>
  );
};

export { NuFeatureCard };
